import api from '../api';
import { addNonceToData } from '../NonceService';

const CompaniesService = {
	companyCreate: async (data, config = {}) => {
		const dataWithNonce = await addNonceToData(data);
		return api.post(`/companyCreate`, dataWithNonce, config);
	},
	companyReadByNBTVA: async (nbtva, config = {}) => {
		const dataWithNonce = await addNonceToData({nbtva});
		return api.post(`/companyReadByNBTVA`, dataWithNonce, config);
	},
	companyUpdateDocument: async (companyID, data, config = {}) => {
		const dataWithNonce = await addNonceToData({companyID, data});
		return api.post(`/companyUpdateDocument`, dataWithNonce, config);
	},
	companyUpdateKbis: async (companyID, data, config = {}) => {
		const dataWithNonce = await addNonceToData({companyID, data});
		return api.post(`/companyUpdateKbis`, dataWithNonce, config);
	},
	sirenInformationRead: async (siren, config = {}) => {
		const dataWithNonce = await addNonceToData({siren});
		return api.post(`/sirenInformationRead`, dataWithNonce, config);
	},
};

export default CompaniesService;
